/**
 * recommend post widget handle from backend
 */
class RecommendPostWidgetHandle {
  constructor () {
    $('.recommend_post_select').length > 0 && this.init()
    
    this._input = null
    this._selectBox = null
    this._selectedBox = null
  }
  
  init () {
    //  event handle
    this._eventHandle()
    
    //  sortable
    this._sortableHandle()
  }
  
  /**
   * handle sortable item
   * @private
   */
  _sortableHandle () {
    $('.recommend_post_selected_box:not(.ui-sortable)').sortable({
      update: (ev, ui) => {
        //  update recommend posts id
        let idArr = []
        ui.item.parent().children().map((k, el) => {
          idArr.push(el.dataset.id)
          $(el).find('.num').text(k + 1)
        })
        ui.item.parent().parent().find('.recommend_posts').val(idArr.join(','))
        
        
        ui.item.parents('form').eq(0).find('.widget-control-save').get(0).disabled = false
      }
    });
  }
  
  /**
   * update element
   * @private
   */
  _updateEl (target) {
    let parent = $(target).parents('.widget-content').eq(0)
    this._input = parent.find('input.recommend_posts')
    this._selectBox = parent.find('.recommend_post_select_box')
    this._selectedBox = parent.find('.recommend_post_selected_box')
  }
  
  /**
   * event handle
   * @private
   */
  _eventHandle () {
    //  search text
    $(document).on('keydown', '.recommend_post_select', ev => {
      let target = ev.currentTarget
      this._updateEl(target)
      
      if (ev.keyCode === 13) {
        ev.preventDefault()
        
        this._selectBox.html('Loading....')
        this._searchText(target.value.trim())
        return false
      }
    })
    
    //  add item
    $(document).on('click', '.recommend_post_item .dashicons-plus', ev => {
      let parent = $(ev.currentTarget).parent()
      let id = parent.get(0).dataset.id
      let name = parent.text()
      
      this._updateEl(parent.parents('form').eq(0).find('.recommend_post_select'))
      
      //  check have exist
      let isExist = false
      this._selectedBox.children().map((k, el) => {
        if (parseInt(el.dataset.id) === parseInt(id)) {
          isExist = true
        }
      })
      
      !isExist && this._addItem(id, name)
    })
    
    //  remove item
    $(document).on('click', '.recommend_post_item .dashicons-no-alt', ev => this._removeItem($(ev.currentTarget).parent()))
    
    //  ajax save widget successful
    $(document).ajaxSuccess((e, xhr, settings) => {
      let widget_id_base = 'recommend-post';
      
      if (settings && settings.data && settings.data.search && settings.data.search('action=save-widget') != -1 && settings.data.search('id_base=' + widget_id_base) != -1) {
        this._sortableHandle()
      }
    })
  }
  
  /**
   * remove item
   * @private
   */
  _removeItem (item) {
    this._updateEl(item.parents('form').eq(0).find('.recommend_post_select'))
    item.parents('form').eq(0).find('.widget-control-save').get(0).disabled = false
    //  add to input
    let arr = this._input.val() ? this._input.val().split(',') : []
    arr.splice(arr.indexOf(item.get(0).dataset.id), 1)
    this._input.val(arr.join(','))
    
    item.remove()
  }
  
  /**
   * add item
   * @param id
   * @param name
   * @private
   */
  _addItem (id, name) {
    //  add to input
    let arr = this._input.val() ? this._input.val().split(',') : []
    arr.push(id)
    this._input.val(arr.join(','))
    
    this._selectedBox.append(`<div class="recommend_post_item" data-id="${id}">
    <span class="num">${this._selectedBox.children().length + 1}</span>
    <span class="name">${name}</span>
    <span class="dashicons dashicons-no-alt"></span>
    </div>`)
  }
  
  /**
   * handle search text event
   * @private
   */
  _searchText (value) {
    //  before
    $.ajax({
      url: window.ajaxurl,
      type:'post',
      data: {
        action: 'get_posts_by_title',
        term: value,
        image_default: ''
      },
      dataType: 'json'
    }).then(data => {
      if (data.length > 0) {
        this._selectBox.html('')
        data.map((item, k) => {
          this._selectBox.append(`<div class="recommend_post_item" data-id="${item.id}">${item.text} <span class="dashicons dashicons-plus"></span></div>`)
        })
      } else {
        this._selectBox.html('Not Fined Post.')
      }
    })
  }
}

export default RecommendPostWidgetHandle
